import logError from '@/utils/errors/logError';

import {wafProtectionService} from './WafProtectionService';

export const initializeWaf = async () => {
  try {
    wafProtectionService.loadScript();
  } catch (error) {
    logError(error, {
      fileName: 'WafProtectionService',
      functionName: 'InitializeWaf',
    });
  }
};

export const getWafProtectionService = () => wafProtectionService;
